var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SystemErrorAlert'),(!_vm.is_ready)?_c('div',[_c('load-overlay',{attrs:{"absolute":true,"activate":true}})],1):(_vm.is_login == false)?_c('OfflineHome'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }